import { ensureValidToken, useAuthStore } from './auth';

export default async function currentSession() {
  const jwtToken = (await ensureValidToken()) ?? '';
  const email = useAuthStore.getState().session?.email ?? '';
  return { jwtToken, email };
}
